import SidebarBookingsRepliesNewController from 'uplisting-frontend/pods/-sidebar/bookings/replies/new/controller';

export default class ProtectionOverviewBookingsRepliesNewController extends SidebarBookingsRepliesNewController {}
